export { default } from './BancoAutoFinancieMoto';
